import React from 'react';
import PropTypes from 'prop-types';
import { Button, Heading, Box, Text } from '@front/gatsby-ui';
import { setAssignmentOrder } from '@front/blocks/src/order-assignment';
import Container from 'Components/container';
import { FluidItem } from 'Components/adrow';

import ctaImage from 'Img/pic_tech-discovery.svg';

const CtaLanding = ({ scroll, buttonText, renderCta, sx, variant, ...rest }) => (
  <Container
    display={{ _: 'block', md: 'flex' }}
    py={{ _: 4, md: '56px' }}
    px={{ _: 3, md: '80px' }}
    sx={{
      backgroundColor: 'secondary.1',
      ...sx,
    }}
    {...rest}
  >
    <FluidItem
      width={{
        md: '60%',
      }}
      pr={{
        md: 3,
      }}
    >
      {renderCta()}

      <Button
        variant={variant}
        mt={4}
        onClick={() => (scroll ? scroll() : setAssignmentOrder({ threshold: 250 }))}
      >
        {buttonText}
      </Button>
    </FluidItem>
    <Box
      pt={{ _: 3, md: 0 }}
      margin="0 auto"
      width="fit-content"
    >
      <img
        src={ctaImage}
        alt="Programming experts with years of experience"
        loading="lazy"
        width="321px"
        height="326px"
      />
    </Box>
  </Container>
);

CtaLanding.propTypes = {
  scroll: PropTypes.func,
  variant: PropTypes.string,
  buttonText: PropTypes.string,
  renderCta: PropTypes.func,
  sx: PropTypes.shape({}),
};

CtaLanding.defaultProps = {
  scroll: null,
  sx: {},
  buttonText: 'Hire an Expert Now',
  variant: 'secondary',
  renderCta: () => (
    <>
      <Heading
        as="h2"
        variant="h2"
      >
        Programming experts with years of experience
      </Heading>

      <Text color="basic.4">
        Your order is in good hands -- coding is our middle name, and our first name is quality. Our
        Support Team will find the most suitable specialist to do your programming assignment.
      </Text>
    </>
  ),
};

export default CtaLanding;
